// extracted by mini-css-extract-plugin
export default {"goal_item":"styles_goal_item__1J4xm","complete":"styles_complete__t6sId","incomplete":"styles_incomplete__eYFdD"};